import React, { useEffect } from "react";
import { useState, useContext } from "react";
import ProductCarousel from "components/ShowCase/ProductCarousel/ProductCarousel";
import Products from "components/ShowCase/Products/Products";
import ShopInfo from "components/ShowCase/ShopInfo/ShopInfo";
import TermsOfSaleModal from "components/ShowCase/TermsOfSaleModal";
import EditShopInfoModal from "components/ShowCase/EditShopInfoModal";
import { createPortal } from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import "components/ShowCase/showCase.scss";
import { sendRequestAPI3 } from "hooks/useAxios";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { NavLink } from "react-router-dom";
import { baseURL } from "constants/constants";
import { FaShopify } from "react-icons/fa";
import { GrTableAdd } from "react-icons/gr";
// import SingleProduct from "components/ShowCase/Products/SingleProduct.jsx";
// import GroupProduct from "components/ShowCase/Products/GroupProduct.jsx";
import { useParams } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Loader from "utils/Loader";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
const ShowCase = ({ logo }) => {
  const [shopinfo, setShopinfo] = useState({});
  const [amazingProducts, setAmazingProducts] = useState([]);
  const [productList, setProductList] = useState([]);
  const [shopInfoUpdater, setShopInfoUpdater] = useState(false);
  let bId = useParams();
  const [loading, setLoading] = useState(true);
  // console.log("b id :", bId);
  const navigate = useNavigate();
  const auth = useContext(WithAuthentication);
  const typeLogin = "adminShop";
  function BasicExample() {
    return (
      <Dropdown>
        <Dropdown.Toggle variant="light" id="dropdown-basic">
          پنل فروشگاه
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {shopinfo.type == "1" ? (
            <>
              <Dropdown.Item
                href={`/shop/financial-department/${bId.businessId}`}
              >
                امورمالی
              </Dropdown.Item>
              <Dropdown.Item href="/admin-panel/orders">سفارشات</Dropdown.Item>

              <Dropdown.Item href="/admin-panel/GroupShoppingList">
                خریدگروهی
              </Dropdown.Item>
            </>
          ) : (
            <>
              <Dropdown.Item href="#/action-1">امور مالی</Dropdown.Item>
              <Dropdown.Item href="/admin-panel/GroupShoppingList">
                خریدگروهی
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  useEffect(() => {
    async function loadPage() {
      await sendRequestAPI3("get_vitrin_info", { bid: bId.businessId }).then(
        ({ data: { data, status } }) => {
          if (status == 1) {
            setShopinfo({
              shopname: data.Businesses.title,
              instagramaddress: data.Businesses.instagram,
              whatsappaddress: data.Businesses.whatsapp,
              address: data.Businesses.address,
              rate: +data.Businesses.rating,
              cover: data.cover.length > 0 ? baseURL + data.cover[0].url : "",
              logo: data.logo.length > 0 ? baseURL + data.logo[0].url : "",
              admin_id: data.Businesses.admin_id,
              type: data.Businesses.type,
            });
          } else if (status == -2) {
            navigate("/", {
              replace: true,
            });
          }
        }
      );

      await sendRequestAPI3("get_products_list", {
        bid: bId.businessId,
        is_amazing: 1,
      }).then(({ data: { data } }) => {
        setAmazingProducts(data);
      });
      await sendRequestAPI3("get_products_list", {
        bid: bId.businessId,
        is_amazing: 0,
        single: 2,
      }).then(({ data: { data } }) => {
        setProductList(data);
        setLoading(false);
      });
    }
    loadPage();
  }, [shopInfoUpdater, bId]);

  useEffect(() => ReactTooltip.rebuild());

  return (
    <div className="show-case-container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{` ${shopinfo.shopname}`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {loading && <Loader></Loader>}
      <div>
        {/* <div className="d-flex justify-content-end mt-3">
          {auth.userInfo.userType != -1 &&
          shopinfo.admin_id == auth.userInfo.id ? (
            <> {BasicExample()}</>
          ) : (
            ""
          )}
        </div> */}
        {/* <TermsOfSaleModal adminId={shopinfo.admin_id} type={shopinfo.type} /> */}
        {((auth.userInfo.userType != -1 &&
          shopinfo.admin_id == auth.userInfo.id &&
          shopinfo.type == 0) ||
          (auth.userInfo.userType == 0 && shopinfo.type == 0)) && (
          <h5 className="text-center mt-3 col-md-6 col-10 mx-auto pb-2 border-bottom">
            فروشگاه {shopinfo.shopname}
          </h5>
        )}
        {shopinfo.type == 1 && (
          <ShopInfo
            adminId={shopinfo.admin_id}
            data={shopinfo}
            shopInfoUpdater={shopInfoUpdater}
            setShopInfoUpdater={setShopInfoUpdater}
          />
        )}
        <div className="text-center mb-2 mt-3">
          <TermsOfSaleModal
            adminId={shopinfo.admin_id}
            type={shopinfo.type}
            setShopInfoUpdater={setShopInfoUpdater}
          />
          <EditShopInfoModal
            adminId={shopinfo.admin_id}
            data={shopinfo}
            type={shopinfo.type}
            shopInfoUpdater={shopInfoUpdater}
            setShopInfoUpdater={setShopInfoUpdater}
          />

          {auth.userInfo.userType != -1 &&
            shopinfo.admin_id == auth.userInfo.id && (
              <>
                {shopinfo.type == "1" && (
                  <NavLink
                    to={`/shop/orders/${bId.businessId}`}
                    target="_blank"
                  >
                    <button className="  col-lg-2 mx-1 col-sm-3 col-5 py-2 rounded my-1 adminBtn shadow">
                      لیست سفارشات
                    </button>
                  </NavLink>
                )}
                <NavLink
                  to={`/shop/financial-department/${bId.businessId}`}
                  target="_blank"
                >
                  {" "}
                  <button className="  col-lg-2 mx-1 col-sm-3 col-5 py-2 rounded my-1 adminBtn shadow">
                    امورمالی
                  </button>
                </NavLink>

                <NavLink
                  to={`/shop/GroupShoppingList/${bId.businessId}/${shopinfo.type}`}
                  target="_blank"
                >
                  <button className="  col-lg-2 mx-1 col-sm-3 col-5 py-2 rounded my-1 adminBtn shadow">
                    لیست خرید گروهی
                  </button>
                </NavLink>
              </>
            )}
        </div>
        {amazingProducts.length == 0 ? null : (
          <ProductCarousel data={amazingProducts} />
        )}
        <Products
          data={productList}
          adminId={shopinfo.admin_id}
          setShopInfoUpdater={setShopInfoUpdater}
          type={shopinfo.type}
          setLoading={setLoading}
        />
      </div>
    </div>
  );
};

export default ShowCase;
